import * as React from 'react';
import './Promo.scss';
import config from '../../../config';

const Promo = () => {
  const eventTrack = (action: string) => {
    window.gtag('event', action, { 'event_name': action })
  }

  return (
    <div className="promo">
      <div className="center-block">
        <h1 className="title-image">
          SHORTS! ARGO STUDENT COMPETITIONS 2022
        </h1>
        <div className="description">
          Our competition celebrates creativity and talent, offers students a chance to win prizes, and showcases their work across Argo’s diverse community.
        </div>
        <a className="watch-button"
           href={config.competition}
           onClick={eventTrack.bind(this, 'watch_now_click')}
        >Watch now</a>
        {/*<div className="social-links">*/}
        {/*  <a href={config.tiktok}*/}
        {/*     target="_blank"*/}
        {/*     rel="noreferrer"*/}
        {/*     className="item tiktok"*/}
        {/*     onClick={eventTrack.bind(this, 'tiktok_click')}*/}
        {/*  >tiktok</a>*/}

        {/*  <a href={config.instagram}*/}
        {/*     className="item instagram"*/}
        {/*     target="_blank"*/}
        {/*     rel="noreferrer"*/}
        {/*     onClick={eventTrack.bind(this, 'instagram_click')}*/}
        {/*  >instagram</a>*/}

        {/*  <div className="separator"/>*/}

        {/*  <a href={config.twitter}*/}
        {/*     className="item twitter"*/}
        {/*     target="_blank"*/}
        {/*     rel="noreferrer"*/}
        {/*     onClick={eventTrack.bind(this, 'twitter_click')}*/}
        {/*  >twitter</a>*/}

        {/*  <a href={config.discord}*/}
        {/*     className="item discord"*/}
        {/*     target="_blank"*/}
        {/*     rel="noreferrer"*/}
        {/*     onClick={eventTrack.bind(this, 'discord_click')}*/}
        {/*  >facebook</a>*/}
        {/*</div>*/}
        <div id="about"/>
      </div>
    </div>
  );
}

export default Promo;
